// 导入组件
import fullDialog from './src/full-dialog.vue'

// 为组件提供 install 安装方法，供按需引入
fullDialog.install = function (Vue) {
  Vue.component(fullDialog.name, fullDialog)
}

// 默认导出组件
export default fullDialog
